// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'c1b5f2ac45b4830dfbca5394fc46e873dd3ac8a7';
export const BUILD_NUMBER = '245';
export const BUILD_TIMESTAMP = '2026-09-21T02:54:03.750Z';
